import { render, staticRenderFns } from "./fission-campagin.vue?vue&type=template&id=b453faca&scoped=true"
import script from "./fission-campagin.vue?vue&type=script&lang=js"
export * from "./fission-campagin.vue?vue&type=script&lang=js"
import style0 from "./fission-campagin.vue?vue&type=style&index=0&id=b453faca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b453faca",
  null
  
)

export default component.exports